/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nurse-attribute.reducer';

export const NurseAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nurseAttributeEntity = useAppSelector(state => state.nurseAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nurseAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nurseAttribute.detail.title">NurseAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.id}</dd>
          <dt>
            <span id="key">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.key">Key</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.key}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.value">Value</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.value}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.nurseAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{nurseAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.nurseAttribute.nurse">Nurse</Translate>
          </dt>
          <dd>{nurseAttributeEntity.nurse ? nurseAttributeEntity.nurse.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/nurse-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nurse-attribute/${nurseAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NurseAttributeDetail;
